import { Trans } from '@lingui/macro'

import * as React from 'react'

import { H3 } from '~ui/components/typography/Heading/Heading'

import { useProductDetailCtx } from '../contexts/ProductDetailProvider'

type TProps = NoChildren & {
  canCreateOrder?: boolean
}

/**
 * Headline for the product detail modal.
 */
export const ProductDetailModalHeadline: React.FC<TProps> = ({ canCreateOrder = true }) => {
  const { isEditingItem } = useProductDetailCtx()

  const renderLabel = () => {
    if (!canCreateOrder) {
      return <Trans>Product detail</Trans>
    }

    if (isEditingItem) {
      return <Trans>Edit item</Trans>
    }

    return <Trans>Add item to cart</Trans>
  }

  return (
    <H3 textAlign={`center`} fontStyle={`boldSemi`} contrast={`high`} fontSize={`m18`}>
      {renderLabel()}
    </H3>
  )
}
